import { Component, Input, OnInit } from '@angular/core';

import { PortalSettingsService } from 'src/app/core/services/portal-settings.service';
@Component({
  selector: 'app-finalize-submited-modal',
  templateUrl: './finalize-submited-modal.component.html',
  styleUrls: ['./finalize-submited-modal.component.css']
})
export class FinalizeSubmitedModalComponent implements OnInit {
  @Input() data:boolean;
  @Input() proxy:number;
  portalSettings: any;
  modalText: string;

  constructor(private portalSettingsService: PortalSettingsService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
   }

  ngOnInit(): void {
    this.modalText = this.data ? this.portalSettings.BenefitSubmitModalText.ConfigValue : "There was an error finalizing your benefit. Please contact portal administrator.";
  }
  okClicked () {
    if (this.proxy != null)
        window.location.href = "/Approval/BenefitsDashboard";
    else
        window.location.href = "/Employee/BenefitsEnrollment";
  }

}
